export default {
	methods: {
		transBreadcrumb: function (editMode, viewMode, entity) {
			const mapEntities = {
				family: this.$t('lang.views.families.family').toLowerCase(),
				child: this.$t('lang.views.families.child').toLowerCase(),
				document: this.$t('lang.views.documents.document_label').toLowerCase(),
				data: this.$t('lang.views.data.title').toLowerCase(),
				user: this.$t('lang.content.user').toLowerCase(),
				record: this.$t('lang.views.records.title_singular').toLowerCase(),
				option: this.$t('lang.views.options.title_singular').toLowerCase(),
				team: this.$t('lang.views.teams.title_singular').toLowerCase()
			};
			return `${
				editMode || viewMode
					? editMode
						? this.$t('lang.actions.edit')
						: this.$t('lang.actions.see')
					: this.$t('lang.actions.create')
			} ${mapEntities[entity]}`;
		},
		transLoading: function (updateData, editMode, entity) {
			const mapEntities = {
				family: this.$t('lang.views.families.family').toLowerCase(),
				child: this.$t('lang.views.families.child').toLowerCase(),
				document: this.$t('lang.views.documents.document_label').toLowerCase(),
				data: this.$t('lang.views.data.title').toLowerCase(),
				user: this.$t('lang.content.user').toLowerCase(),
				record: this.$t('lang.views.records.title_singular').toLowerCase(),
				option: this.$t('lang.views.options.title_singular').toLowerCase(),
				team: this.$t('lang.views.teams.title_singular').toLowerCase()
			};
			const entityVal = entity ? mapEntities[entity] : '';
			return updateData
				? `${
						!editMode
							? this.$t('lang.views.categories.saving')
							: this.$t('lang.views.categories.updating')} ${entityVal}...`
				: `${this.$t('lang.views.categories.loading')} ${entityVal}...`;
		}
	}
};
